<template>
  <div>
    <div v-if="tableData.checkId === null&&tableData.stateNew === null && !firstIdentification"
         class="identificationMessage">
      <div style="margin-bottom: 50px">认证用户可在平台申请保理保理业务</div>
      <my-button @confirm="() => {this.firstIdentification = true}">前往认证</my-button>
    </div>
    <div v-if="tableData.checkId ===null&&tableData.stateNew === '处理中'" class="identificationMessage">
      <div style="margin-bottom: 50px">您的认证信息已提交，请耐心等候</div>
    </div>
    <div v-if="tableData.checkId  === null&&tableData.stateNew==='失败' && !nofirstIdentification"
         class="identificationMessage">
      <div style="margin-bottom: 50px">{{tableData.noteNew}}</div>
      <my-button @confirm="() => {this.nofirstIdentification = true}">重新认证</my-button>
    </div>
    <Row
      v-if="(nofirstIdentification||tableData.checkId!==null||firstIdentification)&&(tableData.checkId!==null||tableData.stateNew!=='处理中')">
      <Col span="22">
        <div class="container_wang_authIndex">
          <Form ref="ruleCustom" :model="tableData1" :rules="ruleCustom" :label-width="0">
            <table>
              <tr>
                <td class="title" colspan="2">认证信息</td>
              </tr>
                <tr>
                <td>客户名称</td>
                <td>
                  <!--<FormItem prop="realName" v-if="tableData.isreal === 0">-->
                  <FormItem prop="realName">
                    <Input v-model="tableData1.realName" placeholder="公司名称，用于提现"/>
                  </FormItem>
                  <!--<span v-else>{{tableData.realName}}</span>-->
                </td>
              </tr>
              <!--<tr v-if="!isCompany">-->
              <tr>
                <td>法人身份证号</td>
                <td>
                  <FormItem prop="idCard" v-if="tableData.checkId == null">
                    <Input v-model="tableData1.idCard" placeholder="请输入身份证号，用于实名认证"/>
                  </FormItem>
                  <span v-else>{{tableData.idCard}}</span>
                </td>
              </tr>
              <!--<tr v-if="!isCompany">-->
              <tr>
                <td>身份证正面照</td>
                <td>
                  <div style="display: flex;align-items:center; ">
                    <FormItem prop="idCardFrontImgUri">
                      <div style="display: inline-flex">
                        <upload-img :imgName="tableData1.idCardFrontImgUri" @fetchImgUrl="uploadidCardFrontImgUri"
                                    v-if="show||tableData.checkId === null" style="align-self: center"></upload-img>
                        <img-magnifying :imgSrc="tableData.idCardFrontImgUri|imgSrc"
                                        v-if="tableData.checkId !== null"></img-magnifying>
                      </div>
                    </FormItem>
                  </div>
                </td>
              </tr>
              <!--<tr v-if="!isCompany">-->
              <tr>
                <td style="height: 90px">身份证反面照</td>
                <td style="height: 90px">
                  <div style="display: flex;align-items:center; ">
                    <FormItem prop="idCardBackImgUri">
                      <div style="display: inline-flex">
                        <div style="align-self: center">
                          <upload-img :imgName="tableData1.idCardBackImgUri" @fetchImgUrl="uploadidCardBackImgUri"
                                      v-if="show||tableData.checkId === null"></upload-img>
                        </div>
                        <img-magnifying :imgSrc="tableData.idCardBackImgUri | imgSrc"
                                        v-if="tableData.checkId !== null"></img-magnifying>
                      </div>
                    </FormItem>
                  </div>
                </td>
              </tr>
              <tr v-if="isCompany">
                <td style="height: 90px">营业执照</td>
                <td style="height: 90px">
                  <div style="display: flex;align-items:center; ">
                    <FormItem prop="licenseImgUri">
                      <div style="display: inline-flex">
                        <div style="align-self: center">
                          <upload-img :imgName="tableData1.licenseImgUri" @fetchImgUrl="uploadidLicenseImgUri"
                                      v-if="show||tableData.checkId === null"></upload-img>
                        </div>
                        <img-magnifying :imgSrc="tableData.licenseImgUri | imgSrc"
                                        v-if="tableData.checkId !== null"></img-magnifying>
                      </div>
                    </FormItem>
                  </div>
                </td>
              </tr>
              <tr>
                <td>支付密码</td>
                <td>
                  <FormItem prop="cashPassword" v-if="tableData.checkId ==null">
                    <Input v-model="tableData1.cashPassword" placeholder="请输入六位数字密码" type="password" :maxlength="6"/>
                  </FormItem>
                  <div v-else>已设置</div>
                </td>
              </tr>
              <tr v-if="tableData.checkId ==null">
                <td>确认密码</td>
                <td>
                  <FormItem prop="cashPasswordCheck">
                    <Input v-model="tableData1.cashPasswordCheck" placeholder="请再次输入六密码"
                           type="password" :maxlength="6"/>
                  </FormItem>
                </td>
              </tr>
              <tr>
                <td>许可状态</td>
                <td>
                  <span style="color:red"
                        v-if="(tableData.checkId===null&&tableData.stateNew===null)||nofirstIdentification"></span>
                  <span style="color:red" v-if="tableData.checkId!==null&&tableData.stateNew===null">已认证</span>
                  <span style="color:red"
                        v-if="tableData.checkId!==null&&tableData.stateNew==='处理中'">已认证（认证修改审核中）</span>
                  <span style="color: #999;"
                        v-if="(tableData.checkId===null&&tableData.stateNew===null)||nofirstIdentification">（认证用户认证用户可在平台申请保理保理业务）</span>
                </td>
              </tr>
            </table>
          </Form>
          <div style="display: inline-flex;justify-content: center;width: 100%;margin-top: 60px">
            <my-button @confirm="save('ruleCustom')"
                        v-if="((tableData.stateNew === null&&tableData.checkId===null)||show||nofirstIdentification)&&!(tableData.stateNew==='处理中'&&tableData.checkId!==null)">
            提交认证
          </my-button>
            <!--<my-button @click.native="edit" v-if="(tableData.checkId !== null &&! show && tableData.stateNew ===null)">修改-->
            <!--</my-button>-->
            <!--<my-button style="margin-left: 40px" @click.native="cancel" v-if="show&&tableData.stateNew!=='处理中'">取消-->
            <!--</my-button>-->
          </div>
        </div>
      </Col>
    </Row>
    <Modal v-model="tableData.stateNew ==='失败'&&tableData.checkId!==null" width="400" :closable="false"
           class="container_wang_authIndex_modal">
      <div style="text-align:center">
        <p style="font-size: 20px">您的认证修改未通过</p>
        <p style="font-size: 20px">原因：{{tableData.noteNew}}</p>
      </div>
      <div slot="footer" style="display: flex;justify-content: center">
        <my-button @click.native="confirm">确定</my-button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import ApiClient from "@/api/ApiClient";
  import MyButton from '@/components/MyButton'
  import tableEdit from '@/components/tableEdit'
  import uploadImg from '@/components/uploadImg'
  import imgMagnifying from '@/components/imgMagnifying'
  import AppUploadImg from '@/components/AppUploadImg'
  export default {
    name: "authIndex",
    components: {
      MyButton,
      tableEdit,
      uploadImg,
      imgMagnifying,
      AppUploadImg
    },
    data() {
      const validatePass = (rule, value, callback) => {
        let reg = /^\d{6}$/;
        let res = reg.test(value);
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (!res) {
            callback(new Error('请输入6位数字密码'));
          } else {
            if (this.tableData1.cashPasswordCheck !== '') {
              // 对第二个密码框单独验证
              this.$refs.ruleCustom.validateField('cashPasswordCheck');
            }
          }
          callback();
        }
      };
      const validatePassCheck = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.tableData1.cashPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      const validateRealName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('姓名不能为空'));
        } else {
          callback();
        }
      };
      const validatePhone =(rule,value,callback)=>{
        if(!value){
          return callback(new Error('手机号不能为空'));
        }else{
          callback();
        }
      }
      const validateIdCard = (rule, value, callback) => {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        let res = reg.test(value);
        if (!res) {
          return callback(new Error('请输入正确的身份证号码'));
        } else {
          callback();
        }
      };
      const validatePic = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请上传图片'));
        } else {
          callback();
        }
      };
      return {
        tableData: {
          idCardBackImgUri: '',
          idCardFrontImgUri: '',
          licenseImgUri:'',
          cashPassword: '',
          phone:'',
          realName:'',
          idCard:'',
          detailId:'',
          checkIdNew:''
        },
        tableData1:{
          cashPassword: "",
          idCard: "",
          idCardBackImgUri: "",
          licenseImgUri:'',
          idCardFrontImgUri: "",
          realName: "",
          phone:""
        },
        firstIdentification: false,
        nofirstIdentification: false,
        isclickSave: false,
        show: false,
        currentUser:{},
        isCompany:false,
        ruleCustom: {
          cashPassword: [
            {validator: validatePass, trigger: 'blur'}
          ],
          cashPasswordCheck: [
            {validator: validatePassCheck, trigger: 'blur'}
          ],
          realName: [
            {validator: validateRealName, trigger: 'blur'}
          ],
          phone:[
            {validator:validatePhone,trigger:'blur'}
          ],
          idCard: [
            {validator: validateIdCard, trigger: 'blur'}
          ],
          idCardBackImgUri: [
            {validator: validatePic, trigger: 'blur'}
          ],
          idCardFrontImgUri: [
            {validator: validatePic, trigger: 'blur'}
          ],
        }
      }
    },
    mounted() {
      //判断用户资料审核状态
      ApiClient.get('/desktop/profile/detail.do').then(data => {
        if(data.detailId == null && data.stateNew == null){
          this.$router.push({name:'userInfo'})
        }
        if(data.stateNew == '处理中'){
          this.$router.push({name:'profileCheckPending'})
        }
        if(data.stateNew == '失败'){
          ApiClient.get('/desktop/profile/checkFail.do',{
            id:this.formCustom.detailIdNew
          }).then(data=>{
            this.$router.push({name:'checkFailed'})
          })
        }
      })
      //判断认证状态
      ApiClient.get('/desktop/profile/identification.do').then(data=>{
          this.tableData=data;
          if(this.tableData.detailId!== null && this.tableData.stateNew === '处理中'){
            this.tableData.state  = '审核中'
            this.$router.push({name:'checkPending'})
          }
          if(this.tableData.detailId !== null && this.tableData.stateNew === null){
            this.tableData.state  = '已审核';
            this.$router.push({name:'authIndex'})
          }
          if(this.tableData.detailId == null && this.tableData.stateNew == '失败'){
            ApiClient.get('/desktop/profile/identificationFail.do',{
              id:this.tableData.checkIdNew
            }).then(data=>{
              this.$router.push({name:'checkFailed'})
            })
          }
      })
      this.fetchData();
      this.currentUser = JSON.parse(window.sessionStorage.getItem('currentUser'));
      this.isCompany = (this.currentUser.accountType=='company');
    },
    activated() {
     this.fetchData();
    },
    methods: {
      fetchData() {
        ApiClient.get('/desktop/profile/identification.do').then(data => {
          this.tableData = Object.assign({}, this.tableData, data);
          this.tableData1.realName = this.tableData.realName;
          if (this.tableData.checkId === null && this.tableData.stateNew === null) {
            this.tableData.state = '未认证';
          }
          if (this.tableData.checkId !== null && this.tableData.stateNew === '处理中'){
            this.tableData.state = '已认证（认证修改审核中）';
          }
          if (this.tableData.checkId !== null && this.tableData.stateNew === null){
            this.tableData.state = '已认证';
          }
          if (this.tableData.checkId === null && this.tableData.stateNew === '失败') {
            ApiClient.get('/desktop/profile/identificationFail.do', {
              id: this.tableData.checkIdNew
            }).then(data => {

            })
          }
        });
      },
      uploadidCardFrontImgUri(evtValue) {
        this.tableData1.idCardFrontImgUri = evtValue;
      },
      uploadidCardBackImgUri(evtValue) {
        this.tableData1.idCardBackImgUri = evtValue;
      },
      uploadidLicenseImgUri(evtValue){
        this.tableData1.licenseImgUri=evtValue;
      },
      edit() {
        this.show = true;
        this.editable = true;
      },
      cancel() {
        this.show = false
      },
      save(name) {
        this.isclickSave = false;
        this.$refs[name].validate((valid) => {
          if (valid) {
            ApiClient.post('/desktop/profile/check.do', this.tableData1).then(data => {
              this.fetchData();
            })

          } else {
            this.$Message.error('请完善信息');
          }
        })
      },
      confirm() {
        this.tableData.stateNew = null;
        ApiClient.get('/desktop/profile/identificationFail.do', {id: this.tableData.checkIdNew}).then(data => {
          this.fetchData();
        })

      }
    },
  }
</script>

<style scoped lang="less">
  @import '~@/app.less';

  .title {
    font-size: @small-f;
    font-weight: 700;
  }

  table {
    border-collapse: collapse;
    margin-left: 60px;
    margin-top: 16px;
    width: 100%;
    tr td {
      border: 1px solid #D8D8D8;
      height: 42px;
      padding-left: 20px;
    }
    tr td:nth-child(2n+1) {
      width: 17%;
    }
    tr td:nth-child(2n) {
      width: 57%;
    }
  }

  table tr:nth-child(2n+1) {
    background-color: #F6F6F5;
  }

  table tr:last-child, table tr:nth-last-child(3) {
    background: #fff;
  }

  img {
    height: 80px;
    display: block;
  }

  .identificationMessage {
    color: red;
    font-size: @big-f;
    text-align: center;
    margin-top: 100px;
  }


</style>

<style lang="less">
  .container_wang_authIndex {
    .ivu-input {
      width: 50%;
    }
    .ivu-form-item {
      margin-bottom: 0;
    }
    .ivu-form-item-error-tip {
      position: absolute;
      top: 20%;
      left: 52%;
    }
    .ivu-form-item {
      width: 100%;
    }
    .ivu-form-item-content {
      line-height: normal;
    }
  }

  .container_wang_authIndex_modal .ivu-modal {
    top: 50%;
    margin-top: -80px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/authIndex.vue